import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractSwitchInput} from "../abstract-switch-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterSwitchInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-switch-input",
    templateUrl: "./filter-switch-input.component.html"
})
export class FUIFilterSwitchInputComponent extends FUIAbstractSwitchInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
